import api from '../../plugins/api';

const reassignCar = ({ orderId, newCarId }) => {
  return api.post('/api/crm/deals/reassignCar', { orderId, newCarId });
};

export default reassignCar;
